/**
 * Site-wide constants: identity, navigation, and contact details.
 *
 * Anything that appears in more than one place - the company name, the email
 * address, the nav order - belongs here rather than inline in a component.
 */

export const site = {
  /** Legal/brand name. The repo and domain are "hellokando"; the company is "Kando". */
  name: 'Kando',
  legalName: 'Kando',
  /**
   * The line the whole brand hangs on. It is the page title suffix, the footer
   * statement and the hero heading - if you change it, change it everywhere.
   */
  tagline: 'We make ideas happen',
  /**
   * One-sentence positioning. Used as the default meta description and as the
   * fallback social-share summary.
   */
  description:
    'Kando is a software and AI consultancy. Bring us the idea you have been meaning to build, and we will get it live.',

  /** Canonical origin. Overridden per environment by VITE_SITE_URL. */
  url: import.meta.env.VITE_SITE_URL ?? 'https://hellokando.com',

  email: 'support@hellokando.com',

  /** Endpoint for contact-form submissions (a Cloud Function). */
  contactEndpoint: import.meta.env.VITE_CONTACT_ENDPOINT ?? '',
} as const;

export interface NavItem {
  readonly label: string;
  readonly to: string;
}

/** Primary navigation, in display order. */
export const navItems: readonly NavItem[] = [
  { label: 'Services', to: '/services' },
  { label: 'Work', to: '/work' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];
